import { Component, Inject, OnInit } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Offer } from 'src/app/lib/offer/classes';
import { IOffersProviderService, OFFERS_PROVIDER_SERVICE } from '../../../interfaces';

@Component({
  selector: 'app-offer-table',
  templateUrl: './offer-table.component.html',
  styleUrls: ['./offer-table.component.css']
})
export class OfferTableComponent implements OnInit {

  columns = [ 'offernumber', 'offertitle', 'offerstate', 'controls' ];
  footerColumns = [ 'offernumber' ];

  active: string = 'offernumber';
  direction: SortDirection = 'asc';

  constructor(
    @Inject(OFFERS_PROVIDER_SERVICE) public providerService: IOffersProviderService,
    private _router: Router
  ) { }

  ngOnInit(): void { Offer}

  showOffer = (offer: Offer) => this._router.navigate(['/offer-details', offer.offerid]);

  sortData(sort: Sort){
    this.active = sort.active;
    this.direction = sort.direction;
  }

}
